// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","Content":"Layout_Content__gynaM","mainLayouts":"Layout_mainLayouts__vDoM5","mobileLayout":"Layout_mobileLayout__+3evC"};